import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import DeviceAppearanceNew from 'client/components/core/Sidebar/components/Settings/options/DeviceAppearance/DeviceAppearanceNew'
import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import React from 'react'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import { AgreementInterface } from 'src/shared/entities/agreement/agreement.schema'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { PaymentSettingsContainerUI } from './ui/payment-settings-container'

const getPaymentSettingsLink = (linkText: string) => `
  <a
    href="${process.env.SYSTEME_IO_HOST}/dashboard/profile/payment-settings"
    target="_blank"
  >
    ${linkText}
  </a>
`

export interface AgreementSettingsProps {
  entity: AgreementInterface
  defaultEntity?: AgreementInterface
}

const NewAgreementSettings = ({
  entity,
  defaultEntity,
}: AgreementSettingsProps) => {
  const { t } = useTypedTranslation()
  const updateProp = useUpdateProp(entity)
  const { isMobile } = useDeviceModeContext()

  return (
    <>
      <PaymentSettingsContainerUI
        // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
        dangerouslySetInnerHTML={{
          __html: t('entity_settings.agreement.read_only.text_icu', {
            link: getPaymentSettingsLink(
              t('entity_settings.agreement.read_only.link_text'),
            ),
          }),
        }}
      />

      <SizeAndPositionGroup
        margin={isMobile ? entity.mobileMargin : entity.margin}
        defaultMargin={
          isMobile ? defaultEntity?.mobileMargin : defaultEntity?.margin
        }
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />

      <DeviceAppearanceNew entity={entity} />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}

export default NewAgreementSettings
